import { Switch, withRouter, Route, Redirect } from 'react-router-dom';
import { lang } from './config/app.config';
import Routes from './config/routes.config';
import NotFound from './pages/404';
import AppRoute from './routes/App';


function App() {
  return (
    <>
      <Switch>

        <Route exact path="/">
          <Redirect to={"/" + lang} />
        </Route>

        {
          Routes.map((route, i) => {
            const { component, path, layout, isProvince } = route;
            return (
              <AppRoute
                key={i}
                component={component}
                layout={layout}
                isProvince={isProvince}
                path={"/:lang" + path}
                exact
              />
            );
          })
        }
        <Route path="/*" component={NotFound} />
      </Switch>
    </>
  );
}

export default withRouter(App);
